import { render, staticRenderFns } from "./ventas-esim.vue?vue&type=template&id=48303987&scoped=true&"
import script from "./ventas-esim.vue?vue&type=script&lang=js&"
export * from "./ventas-esim.vue?vue&type=script&lang=js&"
import style0 from "./ventas-esim.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ventas-esim.vue?vue&type=style&index=1&id=48303987&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48303987",
  null
  
)

export default component.exports